<template>
  <div id="index">
    <div class="main">
      <img :src="imgUrl" :width="bannerWidth" />
    </div>
    <bottomWrapper />
  </div>
</template>

<script>
// @ is an alias to /src
import bottomWrapper from "@/views/component/bottom.vue";
export default {
  name: "index",
  components: {
    bottomWrapper
  },
  data() {
    return {
      imgUrl: "",
      bannerWidth: 1020,
      clientWidth: 1920
    };
  },
  methods: {
    changeClass() {
      this.imgUrl = this.$gf.sysParam(this.$gf.lang(), "banner");
      if (!this.imgUrl) {
        if (this.$gf.lang() === "cn") {
          this.imgUrl =
            pub.staticCDNUrl +
            "dentalCloud/home_banner.png?x-oss-process=image/resize,w_" +
            this.bannerWidth;
        } else {
          this.imgUrl =
            pub.staticCDNUrl +
            "dentalCloud/home_banner_en.png?x-oss-process=image/resize,w_" +
            this.bannerWidth;
        }
      }
    },
    setBanner() {
      window.screenWidth = document.body.clientWidth;
      console.log("document.body.clientWidth: ", window.screenWidth);
      if (window.screenWidth > 1020) {
        this.bannerWidth = Math.floor(window.screenWidth * 0.65);
      } else {
        this.bannerWidth = Math.floor(window.screenWidth * 0.95);
      }
      this.changeClass();
    }
  },
  watch: {
    clientWidth: function(o, n) {
      console.log("wo: ", o);
      console.log("wn: ", n);
      this.setBanner();
    }
  },
  mounted() {
    console.log("mounted:", pub.staticCDNUrl);
    // if (this.$gf.lang() === "cn") {
    // this.imgUrl = pub.staticCDNUrl+ "dentalCloud/home_banner.png?x-oss-process=image/resize,w_1200";
    // } else {
    // this.imgUrl = pub.staticCDNUrl+ "dentalCloud/home_banner_en.png?x-oss-process=image/resize,w_1200";
    // }
    this.imgUrl = this.$gf.sysParam(this.$gf.lang(), "banner");
    this.clientWidth = document.body.clientWidth;
    this.setBanner();
    const that = this;
    window.addEventListener("resize", function() {
      return (() => {
        window.screenWidth = document.body.clientWidth;
        that.clientWidth = window.screenWidth;
      })();
    });
  },
  created() {
    // console.log("created:",pub.staticCDNUrl);
    var s = this;
    this.$EventBus.$on("clang", v => {
      console.log("new lang: ", v);
      s.changeClass();
      console.log("s.tLang: ", s.tImg);
    });
  }
};
</script>
<style lang="scss">
#index {
  .mben {
    // background-color: #201f22;
    // background-position: center center;
    // background-repeat: no-repeat;
    background-image: url(../../assets/img/home_banner_en.png);
  }
  .mbcn {
    // background-color: #201f22;
    // background-position: center center;
    // background-repeat: no-repeat;
    background-image: url(../../assets/img/home_banner.png);
  }
  .main {
    // padding: 15px 0px;
    background-color: #dce1e7;
    // border-bottom: 1px solid #4b91d1;
    h2 {
      // min-width: 1200px;
      width: 65vw;
      @media only screen and (max-width: 1020px) {
        width: 95vw;
      }
      text-align: left;
      margin: 0 auto;
      border-bottom: 5px solid #4b91d1;
      margin-bottom: 15px;
      padding-bottom: 5px;
    }
  }
}
</style>
